"use client";

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import FullPageLoader from "@/components/FullPageLoader";
import { ROUTES } from "@/config/routes";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, signedOut } = useAuth();

  if (loading) return <FullPageLoader message="Loading..." />;
  // Just signed out: back to the landing page. Otherwise ask them to sign in.
  if (!user) return <Navigate to={signedOut ? ROUTES.HOME : ROUTES.AUTH} replace />;

  return <>{children}</>;
}
